var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2412_7539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.29313 13.5001H3.5C3.36739 13.5001 3.24021 13.4474 3.14645 13.3536C3.05268 13.2599 3 13.1327 3 13.0001V10.207C3.00006 10.0745 3.05266 9.94753 3.14625 9.85383L10.8538 2.14633C10.9475 2.05263 11.0746 2 11.2072 2C11.3397 2 11.4669 2.05263 11.5606 2.14633L14.3538 4.93758C14.4474 5.03134 14.5001 5.15847 14.5001 5.29102C14.5001 5.42357 14.4474 5.5507 14.3538 5.64446L6.64625 13.3538C6.55255 13.4474 6.42556 13.5 6.29313 13.5001Z",
    stroke: "#086DAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4L12.5 7.5",
    stroke: "#086DAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 5.75L4.75 11.75",
    stroke: "#086DAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46811 13.4675L3.03186 10.0312",
    stroke: "#086DAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2412_7539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.49495cba7040f251b352ece6405c34e2.svg";
export { ForwardRef as ReactComponent };